import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/website-build/website-build/src/Layout.tsx";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Title = makeShortcode("Title");
const Section = makeShortcode("Section");
const Image = makeShortcode("Image");
const SubTitle = makeShortcode("SubTitle");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Title mdxType="Title">AI + Urban Hydro Meteorology</Title>
    <Section mdxType="Section">
  <Image src={'https://sjyurbanlab.github.io/website-assets/research-theme/urban-hydro-climate/urban-hydro-climate.png'} alt={'urban hydro climate'} size={'medium'} center mdxType="Image" />
    </Section>
    <Section mdxType="Section">
      <SubTitle mdxType="SubTitle">Reference</SubTitle>
      <p><strong parentName="p">{`Song J`}</strong>{`, Zhang Q, (2026), `}<Link href={'https://doi.org/10.5194/egusphere-egu26-2266'} mdxType="Link">{`AI-uWRF: A Physics-Informed Spatiotemporal Diffusion Transformer for High-Resolution Urban Weather Emulation. `}<em parentName="p">{`European Geosciences Union 2026 (EGU)`}</em>{`, May 2026, Vienna, Austria.`}</Link></p>
      <p>{`Zhang Q, `}<strong parentName="p">{`Song J`}</strong>{` (2026), `}<Link href={'https://doi.org/10.5194/egusphere-egu26-2288'} mdxType="Link">{`An Inductive Spatio-Temporal Graph Network for Fine-Resolution Urban Weather Nowcasting Integrating Multi-Source Data and Physical Constraints. `}<em parentName="p">{`European Geosciences Union 2026 (EGU)`}</em>{`, May 2026, Vienna, Austria.`}</Link></p>
      <p>{`Zhao L, `}<strong parentName="p">{`Song J`}</strong>{` (2026), `}<Link href={'https://doi.org/10.5194/egusphere-egu26-11991'} mdxType="Link">{`Chained Nowcasting of High Spatiotemporal Resolution Urban Rainfall and Inundation Risk Using Deep Learning. `}<em parentName="p">{`European Geosciences Union 2026 (EGU)`}</em>{`, May 2026, Vienna, Austria.`}</Link></p>
      <p>{`Zhou Z, `}<strong parentName="p">{`Song J`}</strong>{` (2026), `}<Link href={'https://doi.org/10.5194/egusphere-egu26-15790'} mdxType="Link">{`High Spatiotemporal Mapping of Urban Evapotranspiration via a Hybrid Physics-Based and Machine Learning Framework. `}<em parentName="p">{`European Geosciences Union 2026 (EGU)`}</em>{`, May 2026, Vienna, Austria.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H, Wang C (2018). `}<Link href={'https://doi.org/10.1029/2018JD028302'} mdxType="Link">{`The regional impact of urban heat mitigation strategies on planetary boundary-layer dynamics over a semiarid city. `}<em parentName="p">{`Journal of Geophysical Research: Atmosphere`}</em>{`, 123(3), 6410-6422.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Wang Z-H, Myint SW, Wang C (2017). `}<Link href={'https://doi.org/10.1016/j.landurbplan.2017.06.024'} mdxType="Link">{`The hysteresis effect on surface-air temperature relationship and its implications to urban planning: An examination in Phoenix, Arizona, USA. `}<em parentName="p">{`Landscape and Urban Planning`}</em>{`, 167, 198-211.`}</Link></p>
      <p><strong parentName="p">{`Song J`}</strong>{`, Xia J, Zhang L, Wang Z-H, Wan H, She D (2016). `}<Link href={'https://doi.org/10.2166/nh.2015.155'} mdxType="Link">{`Streamflow prediction in ungauged basins by regressive regionalization: a case study in Huai River Basin, China. `}<em parentName="p">{`Hydrology Research`}</em>{`, 47(5), 1053-1068.`}</Link></p>
    </Section>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      